// src/components/checkatrade-logo/checkatrade-logo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var logoTypeOptions = [
  "REGULAR",
  "GRAYSCALE",
  "DARK_MODE",
  "BLUE_WITH_WHITE_TICK"
];
var catLogoTypeOptions = ["fullLogo", "icon"];
var FullWidthLogo = (props) => {
  const contrastColor = props.type === "DARK_MODE" ? "#FFFFFF" : "#040154";
  const fillColour = "#FF3F3F";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      role: "presentation",
      viewBox: "0 0 123 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M9.46794 7.27676c-.26447.41102-.51815.82872-.76373 1.25043-.22669-.34164-.45338-.68327-.68277-1.0249l-.0027-.00267c-.44798-.65124-3.17366.25622-2.86736.73531.63015.93549 2.03886 3.06537 2.11038 3.17207.32924.4885.87168.5392 1.93226.287.56943-.1562.82718-.6966.91618-.8968.0783-.1722.4925-1.0436.7165-1.47331.6841-1.31716 1.4668-2.59562 2.3357-3.81802.2052-.28692.4129-.57117.6275-.85142.5276-.6926 1.0822-1.36653 1.6637-2.0151.6072-.67926 1.5869-1.6361 2.2224-2.284672.2645-.2709048-1.8877-.4217039-2.5948.218859-.7057.667253-1.7029 1.693483-2.3519 2.419453-.5492.61388-1.0754 1.24777-1.5774 1.89901-.5964.77267-1.15906 1.56804-1.68396 2.38609v-.00133Z",
            fill: contrastColor
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M26.5527 10.9073c0-3.30154 2.3506-5.6476 5.5782-5.6476 3.6244 0 5.8198 2.75843 5.3367 6.2348h-8.1487c.2199 1.8029 1.3615 2.7584 2.9213 2.7584 1.2522 0 2.0861-.5645 2.3506-1.4559h2.7675c-.417 2.238-2.306 3.758-5.0951 3.758-3.4476 0-5.7105-2.3461-5.7105-5.6477Zm8.0394-1.43323c-.0445-1.25977-1.0322-2.08583-2.4598-2.08583s-2.3276.69528-2.6798 2.08583h5.1396ZM38.3911 10.8847c0-3.25753 2.3506-5.62628 5.6443-5.62628 3.0091 0 4.9197 1.65079 5.249 4.21437h-2.7891c-.22-1.12899-1.1645-1.86831-2.4383-1.86831-1.6246 0-2.8552 1.32517-2.8552 3.28022 0 1.955 1.2306 3.3229 2.8552 3.3229 1.3183 0 2.2845-.7166 2.5044-1.8683h2.7891c-.3292 2.3461-2.3722 4.2144-5.2935 4.2144-3.2951 0-5.6659-2.3888-5.6659-5.669ZM54.9082 11.5159l-1.4721 1.4119v3.4537H50.647V.119263h2.7891V9.29932l4.1506-3.86606h3.6904l-4.3489 4.14898 4.7227 6.79926h-3.3383l-3.4044-4.8656Z",
            fill: fillColour
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M61.3222 13.3402c0-2.1499 1.4937-3.3016 4.8535-3.64855l2.1523-.21752v-.23888c0-1.15168-.8353-1.84696-2.0861-1.84696-1.1645 0-1.9552.62989-2.1091 1.75888h-2.7459c.3077-2.17257 2.1522-3.88875 4.8536-3.88875 2.8552 0 4.8752 1.54269 4.8752 4.34382v6.77666h-2.7891v-1.3906c-.4831.8688-1.7568 1.564-3.1629 1.564-2.3276 0-3.8429-1.3251-3.8429-3.2148l.0014.0027Zm4.3921 1.1076c1.603 0 2.6137-1.2597 2.6137-2.8238v-.1735l-2.043.2603c-1.5369.1734-2.2183.6085-2.2183 1.52 0 .7606.6369 1.217 1.6476 1.217Z",
            fill: fillColour
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M73.6202 12.7309V7.66911h-1.7784V5.43114h1.7784V2.75946h2.7891v2.67168h2.6137v2.23797h-2.6137v4.82159c0 1.1076.5708 1.6721 1.4938 1.6721.3737 0 .8568-.0867 1.2076-.2175V16.27c-.483.1948-1.0106.2829-1.5814.2829-2.2399 0-3.9091-1.3465-3.9091-3.8234v.0014ZM80.3417 5.43319h2.7891v1.4773c.6153-.99955 1.9106-1.65079 3.2505-1.65079.4615 0 .8785.0654 1.2293.21753v2.60629c-.5046-.19617-1.0107-.26023-1.4937-.26023-1.603 0-2.9875 1.34651-2.9875 4.40921v4.149h-2.7891V5.43319h.0014ZM87.8539 13.3402c0-2.1499 1.4937-3.3016 4.8536-3.64855l2.1522-.21752v-.23888c0-1.15168-.8353-1.84696-2.0861-1.84696-1.1645 0-1.9552.62989-2.109 1.75888h-2.7459c.3076-2.17257 2.1522-3.88875 4.8536-3.88875 2.8552 0 4.8751 1.54269 4.8751 4.34382v6.77666h-2.7891v-1.3906c-.483.8688-1.7568 1.564-3.1628 1.564-2.3276 0-3.843-1.3251-3.843-3.2148l.0014.0027Zm4.3921 1.1076c1.603 0 2.6137-1.2597 2.6137-2.8238v-.1735l-2.0429.2603c-1.5369.1734-2.2183.6085-2.2183 1.52 0 .7606.6368 1.217 1.6475 1.217ZM98.9438 10.9074c0-3.4537 2.1742-5.64762 5.4472-5.64762 1.406 0 2.746.58718 3.338 1.52V.119263h2.811V16.3815h-2.811v-1.3678c-.593.9341-1.955 1.5427-3.338 1.5427-3.272 0-5.4472-2.194-5.4472-5.6477v-.0013Zm5.7982 3.3016c1.778 0 2.987-1.3679 2.987-3.3016 0-1.93369-1.207-3.30156-2.987-3.30156s-2.987 1.32516-2.987 3.30156 1.252 3.3016 2.987 3.3016ZM111.967 10.9073c0-3.30154 2.351-5.6476 5.578-5.6476 3.625 0 5.82 2.75843 5.337 6.2348h-8.149c.22 1.8029 1.362 2.7584 2.922 2.7584 1.252 0 2.086-.5645 2.35-1.4559h2.768c-.417 2.238-2.306 3.758-5.095 3.758-3.448 0-5.711-2.3461-5.711-5.6477Zm8.04-1.43323c-.045-1.25977-1.033-2.08583-2.46-2.08583-1.428 0-2.328.69528-2.68 2.08583h5.14Z",
            fill: contrastColor
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M11.2751 11.4906c-.4722 1.4907-1.87286 2.5449-3.60947 2.5449-2.6798 0-4.67818-1.9337-4.67818-5.25659 0-3.32292 1.97679-5.25662 4.67818-5.25662 1.12806 0 2.08744.40703 2.74727 1.08896.4223-.6032 1.0943-1.50265 1.7663-2.14322-1.151-.92214-2.70274-1.46528-4.51357-1.46528C3.27216 1.00275 0 3.86926 0 8.77891c0 4.90969 3.33828 7.77619 7.66563 7.77619 3.18987 0 5.51207-1.7149 6.38377-4.129l-2.7743-.9355ZM17.5259 2.02625v4.84158c.5708-.82606 1.8675-1.60674 3.6014-1.60674 2.3938 0 4.1074 1.52 4.1074 4.08358v7.03823h-2.7891V9.93185c0-1.4119-.8568-2.25931-2.1306-2.25931-1.7352 0-2.7891 1.45594-2.7891 3.95276v4.7576h-2.7891V4.80335s.6976-.98753 2.7891-2.7771Z",
            fill: fillColour
          }
        )
      ]
    }
  );
};
var getFillColor = (type) => {
  switch (type) {
    case "GRAYSCALE":
      return {
        circle: "#62687A",
        tick: "#62687A"
      };
    case "BLUE_WITH_WHITE_TICK":
      return {
        circle: "#040154",
        tick: "#FFFFFF"
      };
    case "DARK_MODE":
      return {
        circle: "#FF3F3F",
        tick: "#FFFFFF"
      };
    default:
      return {
        circle: "#FF3F3F",
        tick: "#040154"
      };
  }
};
function IconCheckatradeTick(props = {
  type: "REGULAR"
}) {
  const colors = getFillColor(props.type);
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      role: "presentation",
      xmlns: "http://www.w3.org/2000/svg",
      width: "176",
      height: "169",
      viewBox: "0 0 176 169",
      fill: "none",
      ...props,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: colors.tick,
            d: "M94.568 71.818c-2.607 4.12-5.1 8.31-7.524 12.535-2.229-3.43-4.469-6.849-6.732-10.279l-.023-.023c-4.411-6.526-31.27 2.567-28.26 7.367 6.215 9.38 20.092 30.72 20.793 31.791 3.24 4.892 8.593 5.399 19.047 2.878 5.606-1.566 8.156-6.987 9.029-8.99.77-1.726 4.848-10.463 7.065-14.768a324.53 324.53 0 0 1 23.021-38.271 321.655 321.655 0 0 1 6.181-8.53 333.407 333.407 0 0 1 13.612-17c.92-1.07 1.85-2.14 2.78-3.2 5.986-6.814 15.635-16.402 21.907-22.905 2.609-2.717-18.598-4.225-25.571 2.198-6.95 6.688-16.783 16.978-23.182 24.252a336.937 336.937 0 0 0-15.543 19.038c-7.561 9.99-16.599 23.906-16.6 23.907Z"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            fill: colors.circle,
            d: "M118.302 117.584c-6.193 16.379-22.379 24.689-39.84 24.689-26.939 0-47.02-19.74-47.02-53.672s19.874-53.672 47.02-53.672c8.776 0 16.129 1.669 22.975 5.398l16.865-20.143c-10.845-6.93-24.47-10.98-39.852-10.98-44.147.01-77.036 29.281-77.036 79.409 0 50.127 33.555 79.385 77.048 79.385 31.821 0 55.049-17.254 63.963-41.609l-24.123-8.805Z"
          }
        )
      ]
    }
  );
}
var CheckatradeLogo = ({
  catLogoType = "fullLogo",
  ...restProps
}) => {
  const iconTypeMapping = {
    fullLogo: /* @__PURE__ */ jsx(FullWidthLogo, { ...restProps }),
    icon: /* @__PURE__ */ jsx(IconCheckatradeTick, { ...restProps })
  };
  return iconTypeMapping[catLogoType];
};
export {
  CheckatradeLogo,
  FullWidthLogo,
  IconCheckatradeTick,
  catLogoTypeOptions,
  logoTypeOptions
};
